module.exports = __webpack_public_path__ + "static/media/colicoli21.8b862da6.webp";